<template>
    <div class="bg-wrap">
        <div class="content">
            <div class="item" v-for="(value,index) in questions" v-bind:key="index">
                <span>{{value.question}}</span>
                <div class="space"></div>
                <label @click="toScreen(value.playerId)" v-if="value.playerId!=0">{{print}}</label>
            </div>
        </div>
    </div>

</template>

<script>

    import {toScreen,allCompQuestion} from "@/assets/js/api";

    export default {
        inject: ["reload"], //注入reload方法
        data(){
            return{
                title:"共话新知",
                print:"投屏",
                type:2,
                questions:[]
            }
        },
        methods:{
            async toScreen(playerId){
                    let type =this.type
                    await toScreen({playerId,type})
                    this.$toast("投屏成功")

            },
            async allQuestion(type){
                    const res = await allCompQuestion({type})
                    if(res.data.success){
                        this.questions = res.data.data
                    }
            }
        },
        mounted(){
            this.allQuestion(this.type)
        }

    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        width: 100%;
        max-width: 375px;
        height: 100vh;
        background: #FFF url("../../assets/img/qkds_bg_2.jpg") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        font-size: 15px;
        color: #000;
    }
    .content{
        width: 100%;
        height: 100vh;
        overflow: scroll;
    }

    .item{
        width: 100%;
        text-align: left;
        /*margin: 15px 0;*/
        /*background: #a9acb1;*/
        /*height: 40px ;*/
        /*line-height: 40px;*/
        border-bottom: #0082c5 1px solid;
        display: flex;
        align-items: center;
        span{
            margin-left: 15px;
            width: 85%;
        }
        label{
            /*background: #0082C5;*/
            color: #0082C5;
            border-radius: 5px;
            /*height: 25px;*/
            margin: 0 15px;
            width: 10%;
        }
        .space{
            flex-grow: 1;
        }
    }

</style>